import envConfig from '@hulu/env-config';
import type { LDClient } from 'launchdarkly-js-client-sdk';
import { snakeCase } from 'lodash';
import { fetchLaunchDarklyFlag } from 'mission-control-common-components';

import type { FeatureFlags } from '../../hooks/useFeatureFlags';

let client: LDClient | undefined;

export const setLDClient = (next: LDClient | undefined): void => {
  client = next;
};

export const getFlag = async <K extends keyof FeatureFlags>(
  key: K,
  fallback: FeatureFlags[K] | undefined
): Promise<FeatureFlags[K] | undefined> => {
  if (client) {
    return client.variation(snakeCase(key), fallback) as FeatureFlags[K];
  }

  const idToken = window.localStorage.id_token;
  const clientSideId = envConfig.REACT_APP_LAUNCHDARKLY_CLIENT_SIDE_ID;
  const remoteValue = await fetchLaunchDarklyFlag<FeatureFlags, K>(key, clientSideId, idToken);

  if (remoteValue === null) {
    return fallback;
  }

  return remoteValue;
};
